var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heart_count",on:{"click":_vm.likeItem}},[_c('div',{staticClass:"heart",class:{'on': _vm.likeData.LikeStatus}}),_c('span',[_vm._v(_vm._s(_vm.returnCommas(_vm.likeData.likeCnt)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }